// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.email.HpApiUserEmailUpdateV3Handler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  HpApiUserEmailUpdateV3Handler_confirm,
  HpApiUserEmailUpdateV3Handler_request,
} from '@zg-rentals/ts-hotpads-api-client';

import type {
  HpApiResponseDto,
  HpEmailUpdateConfirmDto,
  HpEmailUpdateRequestDto,
  HpUserCredentialsDto,
} from '@zg-rentals/ts-hotpads-api-client';

export interface HpApiUserEmailUpdateV3Handler_confirm_Args {
  postData: HpEmailUpdateConfirmDto;
}

export type HpApiUserEmailUpdateV3Handler_confirm_Options = UseMutationOptions<
  HpApiResponseDto<HpUserCredentialsDto>,
  unknown,
  HpApiUserEmailUpdateV3Handler_confirm_Args
>;

/**
 * Step 2 of the two-step email update flow. Checks the one-time code against the pending EmailUpdateRequest, then changes the email. Removes any linked Google or Apple sign-in, signs out every other session and emails both addresses
 */
export const useHpApiUserEmailUpdateV3Handler_confirm = ({
  httpClient,
  ...options
}: Omit<HpApiUserEmailUpdateV3Handler_confirm_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiUserEmailUpdateV3Handler_confirm_Args) =>
      HpApiUserEmailUpdateV3Handler_confirm(args.postData, httpClient),
  });
};

export interface HpApiUserEmailUpdateV3Handler_request_Args {
  postData: HpEmailUpdateRequestDto;
}

export type HpApiUserEmailUpdateV3Handler_request_Options = UseMutationOptions<
  HpApiResponseDto<boolean>,
  unknown,
  HpApiUserEmailUpdateV3Handler_request_Args
>;

/**
 * Step 1 of the two-step email update flow. Validates the caller's current password, checks that the new email is not already in use, persists an EmailUpdateRequest record for the user (invalidating any prior in-flight request), and sends an OTP to the new address.
 */
export const useHpApiUserEmailUpdateV3Handler_request = ({
  httpClient,
  ...options
}: Omit<HpApiUserEmailUpdateV3Handler_request_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: HpApiUserEmailUpdateV3Handler_request_Args) =>
      HpApiUserEmailUpdateV3Handler_request(args.postData, httpClient),
  });
};
